import { Box, styled } from '@mui/material';

// Zona scrolleable del menú: crece y scrollea sin empujar el footer. La barra de
// scroll queda OCULTA (sobre todo en el rail colapsado se veía fea) pero el scroll
// sigue funcionando con rueda/touch, así se alcanzan el resto de íconos.
const StyledSidebarNavZone = styled(Box)(() => ({
  flexGrow: 1,
  minHeight: 0,
  overflowX: 'hidden',
  overflowY: 'auto',
  scrollbarWidth: 'none',
  '&::-webkit-scrollbar': { width: 0, height: 0 }
}));

export default StyledSidebarNavZone;
